module.exports = __webpack_public_path__ + "img/Iran.da2d2d93.svg";